<template>
  <div class="p-4">
    <base-button
      :aria-label="paused ? $t.videoPlay : $t.videoPause"
      class="rounded-xs bg-grey-90 bg-op-80 p-1 @hactive:c-grey-60 c-black shadow-sm duration"
    >
      <vf-icon :name="paused ? 'play' : 'pause'" />
    </base-button>
  </div>
</template>

<script lang="ts" setup>
import type { Emits, Props } from '#brands/components/vf/video/VideoControls.vue'

defineProps<Props>()
defineEmits<Emits>()
</script>
